
import Private from './Private';
export const authAssign = ( enterpriseId, brandId ) => {
  

  if (enterpriseId === 'XDZN') { 
    // 查询企业列表
    Private.enterpriseHeadList = [
      { id: 'XDZN,CC01', name: '全部' },
      { id: 'XDZN', name: '仙豆' },
      { id: 'CC01', name: '长城' },
    ];
    // 新增/编辑等个人企业列表
    Private.enterpriseUserList = [
      { id: 'XDZN', name: '仙豆' },
    ];
    
  } else if (enterpriseId === 'CC01') {
    // 查询企业列表
    Private.enterpriseHeadList = [
      { id: 'CC01', name: '长城' },
    ];
    // 新增/编辑等个人企业列表
    Private.enterpriseUserList = [
      { id: 'CC01', name: '长城' },
    ];
  }


  if (brandId === 'CCW001') {
    // 查询品牌列表
    Private.brandHeadList = [
      { id: 'CCW001', name: 'WEY' },
    ];
    // 新增/编辑等个人品牌列表
    Private.brandUserList = [
      { id: 'CCW001', name: 'WEY' },
    ];
  } else if (brandId === 'CCH001') {
    // 查询品牌列表
    Private.brandHeadList = [
      { id: 'CCH001', name: '哈弗' },
    ];
    // 新增/编辑等个人品牌列表
    Private.brandUserList = [
      { id: 'CCH001', name: '哈弗' },
    ];
  } else if (brandId === 'CCO001') {
    // 查询品牌列表
    Private.brandHeadList = [
      { id: 'CCO001', name: '欧拉' },
    ];
    // 新增/编辑等个人品牌列表
    Private.brandUserList = [
      { id: 'CCO001', name: '欧拉' },
    ];
  } else if (brandId === 'CCP001') {
    // 查询品牌列表
    Private.brandHeadList = [
      { id: 'CCP001', name: '长城皮卡' },
    ];
    // 新增/编辑等个人品牌列表
    Private.brandUserList = [
      { id: 'CCP001', name: '长城皮卡' },
    ];
    
  } else if (brandId === 'CCZ001') {
    // 查询品牌列表
    Private.brandHeadList = [
      { id: 'CCZ001,CCW001,CCH001,CCO001,CCP001', name: '全部' },
      { id: 'CCW001', name: 'WEY' },
      { id: 'CCH001', name: '哈弗' },
      { id: 'CCO001', name: '欧拉' },
      { id: 'CCP001', name: '长城皮卡' },
      { id: 'CCZ001', name: '综合' },
    ];
    // 新增/编辑等个人品牌列表
    Private.brandUserList = [
      { id: 'CCZ001', name: '综合' },
    ];
  }
  
  // 个人企业ID 个人品牌ID
  sessionStorage.setItem('PRIVATE_USER_BRANDID', brandId);
  sessionStorage.setItem('PRIVATE_USER_ENTERPRISEID', enterpriseId);
  // 查询默认企业ID 品牌ID
  sessionStorage.setItem('PRIVATE_SEARCH_BRANDID', Private.brandHeadList[0].id);
  sessionStorage.setItem('PRIVATE_SEARCH_ENTERPRISEID', Private.enterpriseHeadList[0].id);
  console.log(brandId,enterpriseId)
};
